export enum FilterType {
  text,
  date,
  datetime,
  number,
  boolean,
  enum,
  autocomplete,
}
